import React, { ReactElement } from 'react';
import FullScreenModal from '../../components/modal/FullScreenModal';
import StyledButton from '../../components/buttons/StyledButton';
import { ModalIds } from '../../components/modal/modalConstants';
import './AnnouncementModal.scss';

type Props = {
    dispatchModalClose: () => void;
    videoSrc: string;
    primaryText: string;
    modalName: ModalIds;
};

const AnnouncementModal = (props: Props): ReactElement => {
    const { dispatchModalClose, videoSrc, primaryText } = props;
    return (
        <FullScreenModal className="AnnouncementModal" autoWidth overlay styled={false} {...props}>
            <div className="video-container">
                <video width={640} height={400} autoPlay muted loop>
                    <source src={videoSrc} type="video/mp4" />
                </video>
            </div>
            <h1 className="primary-text">{primaryText}</h1>
            <StyledButton className="primary" onClick={dispatchModalClose}>
                Check it out
            </StyledButton>
        </FullScreenModal>
    );
};

export default AnnouncementModal;
